export default "__VITE_ASSET__CyNPqHiU__"